import { useOrganizationPermissions } from '@modules/auth/hooks/usePermissions/usePermissionsV2';
import { useOrganization } from 'app/_providers/Organization';

import { DEFAULT_MAX_WORKSPACES } from 'shared/src/workspaces/constants';

const parseMaxWorkspaces = (): number => {
  const envValue = process.env.MAX_DEFAULT_WORKSPACES_OWNED ?? DEFAULT_MAX_WORKSPACES.toString();

  return parseInt(envValue, 10);
};

export const useCanCreateWorkspace = () => {
  const { capabilities, maxWorkspaces } = useOrganization();
  const { loading, permissions } = useOrganizationPermissions(['can_create_workspaces'] as const);

  const maxWorkspacesOwned = maxWorkspaces || parseMaxWorkspaces();
  const isProvisioningEnabled = capabilities?.['cloud.workspace.provisioning']?.enabled ?? false;
  const canCreateWorkspaces = permissions?.can_create_workspaces ?? false;
  const hasCreateWorkspacePermission = isProvisioningEnabled && canCreateWorkspaces;

  return {
    loading,
    canCreateWorkspaces: hasCreateWorkspacePermission,
    maxWorkspaces: maxWorkspacesOwned,
  };
};
